// Config for defining the base fetching URL
var baseURL = ".netlify/functions/users/"
if (!process.env.NODE_ENV || process.env.NODE_ENV === "development")
  baseURL = "http://localhost:5000/" + baseURL
else baseURL = window.location.href + baseURL

var url = window.location.protocol + "//" + window.location.hostname

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development")
  url += ":" + window.location.port

module.exports = global.config = {
  base: baseURL,
  url: url,
}
